export * from './NewsletterIcon'
